import React, { type ComponentProps, useState } from 'react';
import { Form } from 'ALIASED-antd';
import MobileInput from '@components/Patients/MobileInput/MobileInput';
import useUser from '@vl-core/hooks/useUser';
import { useTranslation } from 'react-i18next';
import { RegistrationFormItem, type RegistrationFormItemProps } from '../RegistrationFormItem';
import { useRegistrationFormInstance } from '../useSelfRegistrationFormInstance';

const NAME = 'tel_mobile';

export const PrimaryPhoneNumberFormItem = ({
  inputProps,
  ...props
}: RegistrationFormItemProps & { inputProps?: Partial<ComponentProps<typeof MobileInput>> }) => {
  const user = useUser();

  const { t } = useTranslation('common');

  const [isValid, setIsValid] = useState(false);
  const form = useRegistrationFormInstance();

  const watchedValue = Form.useWatch(NAME, form);

  return (
    <RegistrationFormItem
      name={NAME}
      htmlFor="primary-number-input"
      label={t('Mobile phone number')}
      required
      initialValue={form.getFieldValue(NAME)}
      rules={[
        {
          validator(_, value) {
            const mobileValidated = !!user?.tel_mobile_no;

            if (mobileValidated || (value && isValid)) {
              return Promise.resolve();
            }
            return Promise.reject(new Error(t('This field is invalid')));
          }
        }
      ]}
      {...props}
    >
      <MobileInput
        inputId="primary-number-input"
        mobile={watchedValue || form.getFieldValue(NAME) || user?.tel_mobile_no}
        setMobile={(tel_mobile) => form.setFieldsValue({ tel_mobile })}
        setValidMobile={(isValid) => setIsValid(isValid)}
        autoComplete
        location="self-registration"
        separateTelCode={false}
        {...inputProps}
      />
    </RegistrationFormItem>
  );
};
